import store from '@/store'
import storage from '@/plugins/storage'

// Force logout by clearing Vuex, local storage and redirecting to login.
// Sendbird teardown is fire-and-forget so it can never block logout.
export async function forceLogout() {
  console.log('DEBUG -> [auth] Forcing logout...')
  try {
    const sb = window.__sb
    if (sb && typeof sb.disconnect === 'function') {
      // DO NOT await
      try { sb.disconnect().catch(() => {}) } catch {}
    }

    // Also try the module path, but do not await the import or the disconnect.
    // This runs in the background and cannot block logout.
    import('@/plugins/sendbird/sendbird-client')
      .then(({ useSendbird }) => {
        try {
          const { disconnect } = useSendbird()
          if (typeof disconnect === 'function') {
            const p = disconnect()
            if (p && typeof p.catch === 'function') p.catch(() => {})
          }
        } catch (e) {
          console.warn('DEBUG -> [auth] background Sendbird disconnect failed:', e)
        }
      })
      .catch(() => {}) // ignore chunk load issues entirely
  } catch (e) {
    console.warn('DEBUG -> [auth] Sendbird disconnect skipped:', e)
  }

  try {
    await store.dispatch('auth/clearToken')
    await store.dispatch('auth/clearChatAs')
    await store.dispatch('serviceRequests/updateRequestUnread', { id: null, count: 0 })
    await storage.local.clear()
  } catch (e) {
    console.error('DEBUG -> [auth] Failed to clear local data:', e)
  }

  // Hard navigate (don’t rely on SPA router)
  window.location.replace('/login')
}
